import { useState, useEffect, useCallback } from "react";
import { apiClient } from "@repo/api-client";
import { API_ENDPOINTS } from "@repo/constants";

export interface CityWiseHotel {
  City: string;
  HotelCounts: number;
}

export interface DashboardStats {
  TotalHotels: number;
  PendingHotels: number;
  ActiveHotels: number;
  ExpireHotels: number;
  MTDBookings: number;
  YTDBookings: number;
  MTDRevenue: number;
  YTDRevenue: number;
  MTD_ADR: number;
  YTD_ADR: number;
  TodayIncome: number;
  TodayExpense: number;
  MTDIncome: number;
  MTDExpense: number;
  MTDBalance: number;
  CityWiseHotels: CityWiseHotel[];
}

export interface DashboardData {
  Success: boolean;
  Message: string;
  StatusCode: number;
  Data: DashboardStats[];
}

export const useDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<DashboardStats | null>(null);

  const fetchDashboardData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await apiClient.get<DashboardData>(
        API_ENDPOINTS.getDashboardData,
      );
      if (
        response.data.Success &&
        response.data.Data &&
        response.data.Data.length > 0
      ) {
        setData(response.data.Data[0]);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  return {
    loading,
    data,
    refresh: fetchDashboardData,
  };
};
